import request from '@/modules/huyu-framework/backend/utils/request'

// 查询AI常见问题列表
export function listFaq(query) {
  return request({
    url: '/huyuAI/faq/list',
    method: 'get',
    params: query
  })
}

// 查询AI常见问题树形列表
export function treeListFaq(query) {
  return request({
    url: '/huyuAI/faq/treeList',
    method: 'get',
    params: query
  })
}

// 查询AI常见问题详细
export function getFaq(faqId) {
  return request({
    url: '/huyuAI/faq/' + faqId,
    method: 'get'
  })
}

// 新增AI常见问题
export function addFaq(data) {
  return request({
    url: '/huyuAI/faq',
    method: 'post',
    data: data
  })
}

// 修改AI常见问题
export function updateFaq(data) {
  return request({
    url: '/huyuAI/faq',
    method: 'put',
    data: data
  })
}

// 删除AI常见问题
export function delFaq(faqId) {
  return request({
    url: '/huyuAI/faq/' + faqId,
    method: 'delete'
  })
}
